import { data as currencies } from 'currency-codes';
import { useMemo } from 'react';

function generateCurrencyList(baseCurrency: string) {
  let topCurrencies = ['USD', 'GBP', 'EUR', 'NZD', 'AUD', 'CAD'];

  if (baseCurrency) {
    const currencyIndex = topCurrencies.indexOf(baseCurrency);

    if (currencyIndex !== -1) {
      topCurrencies.splice(currencyIndex, 1);
    }

    topCurrencies = [baseCurrency, ...topCurrencies];
  }

  const topCurrenciesFull = topCurrencies
    .map((currencyCode) => currencies.find((currency) => currency.code === currencyCode))
    .filter((currency) => currency !== undefined);

  return [...topCurrenciesFull, ...currencies].map((currency) => ({
    label: `${currency.code} - ${currency.currency}`,
    value: currency.code,
  }));
}

export function useCurrencyList(baseCurrency: string) {
  return useMemo(() => generateCurrencyList(baseCurrency), [baseCurrency]);
}
